<template>
  <transition name="bounce">
    <div class="main">
      <img src="../assets/logo.png" class="logoImg" />
      <input type="text" class="inputTxt" v-model="userName" placeholder="请输入用户名/授权手机号码" />
      <input type="password" class="inputTxt" v-model="password" placeholder="请输入登录密码" />
      <div class="flexBox">
        <div class="wordBox">
          <input type="checkbox" v-model="cPass" />
          <span>记住密码</span>
        </div>
      </div>
      <input type="button" class="loginBtn" value="登录" @click="login()" />
    </div>
  </transition>
</template>

<script>
import { Toast } from "vant";

// import { post } from "../../request/http.js";
export default {
  data() {
    return {
      userName: "",
      password: "",
      cPass: true,
    };
  },
  components: {
    [Toast.name]: Toast,
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
  },
  methods: {
    login() {
      var _this=this;
      var dd = { account: this.userName, password: this.password };
      this.$get("/api/LoginAPI/CustomerByPhone", dd)
        .then((res) => {
          if (res.IsSucceed) {
            if(_this.cPass==true){
              //记住密码
              var loginData={"account":_this.userName,"password":_this.password};
              localStorage.setItem("loginData",JSON.stringify(loginData));
            }
            else{
              localStorage.removeItem("loginData");
            }
            this.$store.commit("loginData", res.Content);
            this.$router.push({
              path: "/",
            });
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
   
  },
  created: function () {
    var formData = new FormData();
    formData.append("LesseeId", 1);
    formData.append("user", "msgf");
    formData.append("password", "msgf0504");
    console.log(formData);
    //Toast("提示内容");
  },
  mounted: function () {
    if(localStorage.getItem("loginData")){
      //记住密码
      this.cPass=true;
      var loginData=JSON.parse(localStorage.getItem("loginData"));
      this.userName=loginData.account;
      this.password=loginData.password;
    }
    else{
      //未记住密码
      this.cPass=false;
    }
  },
};
</script>

<style scoped>
.main::after {
  content: "";
  background-image: url(../assets/login/bg.jpg);
  opacity: 0.9;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-size: cover;
  height: 100vh;
}
.logoImg {
  width: 236px;
  margin-top: 48px;
  margin-bottom: 90px;
}

.inputTxt {
  -webkit-appearance: none;
  outline: none;
  text-indent: 10px;
  border: none;
  border-radius: 30px;
  border-bottom: 1px solid #dddddd;
  display: block;
  width: 305px;
  font-size: 14px;
  margin: 30px auto;
  line-height: 38px;
}
.flexBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  width: 325px;
}
.wordBox {
  padding: 5px 10px;
  border-radius: 10px;
  text-align: right;
  font-size: 13px;
  color: #ffffff;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.4);
}

.loginBtn {
  color: white;
  background: #e62129;
  display: block;
  width: 267px;
  outline: none;
  -webkit-appearance: none;
  border: none;
  font-size: 15px;
  padding: 10px 0;
  border-radius: 5px;
  margin: 70px auto;
}

.footerBox {
  display: flex;
  align-content: center;
  justify-content: space-between;
  width: 267px;
  margin: 0px auto 10px auto;
}

.footerItem div {
  width: 47px;
  height: 47px;
  background: #efefef;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto;
}

.footerItem img {
  width: 30px;
  height: 30px;
}

.footerItem p {
  text-align: center;
  font-size: 10px;
  margin-top: 10px;
  color: #7a7a7a;
}
input[type="checkbox"] {
  width: 16px;
  height: 16px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
  margin-right: 10px;
  position: relative;
  margin-bottom: 4px;
}

input[type="checkbox"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

input[type="checkbox"]:checked::before {
  content: "\2713";
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px solid #7d7d7d;
  border-radius: 4px;
  color: #7d7d7d;
  font-size: 16px;
  font-weight: bold;
}
</style>
